import React from "react";
import { Navbar3 } from "./components/Navbar3";
import { Header131 } from "./components/Header131";
import { Faq13 } from "./components/Faq13";
import { Contact18 } from "./components/Contact18";

export default function Page() {
  return (
    <div>
      <Navbar3 />
      <Header131 />
      <Faq13 />
      <Contact18 />
    </div>
  );
}
